import { type Nullable, isDefined } from "@sunrise/utils";
import type {
  LivePlayRequest,
  PlayRequest,
  ReplayPlayRequest,
} from "@sunrise/yallo-player-types";

/**
 * Is the playrequest something we can map on EPG events in a timeline?
 *
 * TODO: move to yallo-player-types?
 */
export function isLinearPlayRequest(
  playRequest: Nullable<PlayRequest>,
): playRequest is LivePlayRequest | ReplayPlayRequest {
  return (
    isDefined(playRequest) &&
    (playRequest.type === "live" || playRequest?.type === "replay")
  );
}
